import axios from 'axios';

// Records what the family hearted on the favorites gallery -- which poses, out
// of how many, and whether they pressed "Favorite All" -- against their cart
// (Api::CartsController#favorite_selection). Measurement only: fire-and-forget,
// so a failure is logged and the family's Continue goes ahead regardless.
// Uses the app's global axios baseURL ('/api/v1'), like addBuyAllToCart.
export function recordFavoriteSelection({
  cartId, studentId, packageId, poseIds, posesOffered, usedFavoriteAll,
}) {
  if (!cartId) return;

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  axios
    .post(
      `/carts/${cartId}/favorite_selection`,
      {
        student_id: studentId,
        package_id: packageId,
        pose_ids: poseIds,
        poses_offered: posesOffered,
        used_favorite_all: !!usedFavoriteAll,
      },
      { headers: { 'X-CSRF-Token': csrfToken } },
    )
    // eslint-disable-next-line no-console
    .catch((e) => console.warn('[recordFavoriteSelection] not recorded', e));
}

export default recordFavoriteSelection;
